export const USER_INFO = 'USER_INFO'


// WEBPACK FOOTER //
// ./src/store/modules/user/constant.js